<div class="container-fluid section-card form p-0">
  <div class="skills-head">
    <h3 class="profile-title">Aptitudes</h3>
    <span class="sub-title">Aquí podrás ver las aptitudes del prestador</span>
  </div>
  @if (!supplierSkills) {
    <div class="loader"></div>
  }
  @if (supplierSkills) {
    <dl class="skills-list cont-scroller">
      @for (group of groupedSupplierSkills | keyvalue; track group) {
        <div class="skills-list__row">
          <dt class="group-skill">{{ group.key }}</dt>
          <dd class="skills-list__values">
            @for (jobModel of group.value; track jobModel; let last = $last) {
              <span class="skills">{{ jobModel }}{{ last ? '' : ',' }}</span>
            }
          </dd>
        </div>
      }
    </dl>
    @if (groupedSupplierSkills.size === 0) {
      <p class="empty-message">Todavía no tiene aptitudes cargadas.</p>
    }
  }
      <div class="line"></div>
      <div class="footer d-flex justify-content-end">
        <button
          id="addButton"
          class="no-back-color"
          (click)="openSkillsForm()"
          [disabled]="!usrSvc.hasPermission('add:contractor')"
          >
          Editar aptitudes
        </button>
      </div>
    </div>
    <div
      class="skills-modal d-flex align-items-center justify-content-center w-100"
      [ngClass]="{ expanded: showSkillForm }"
      >
      @if (showSkillForm) {
        <div class="modal-container">
          <div class="skills-container h-100 mt-4 pb-3 ms-auto me-auto">
            <div class="mt-3 skill-title">
              <h2 class="pt-4 ms-4">Editar aptitudes del prestador</h2>
            </div>
            <form [formGroup]="skillsForm" (ngSubmit)="onSubmit()" autocomplete="off">
              <div class="mb-4 pt-4 ms-3 ps-2">
                <span
                  >Selecciona las aptitudes que quieres agregar o quitarle al
                  prestador</span
                  >
                </div>
                @for (group of taskGroups; track group; let i = $index) {
                  <div
                    class="row pe-5"
                    [ngClass]="i < taskGroups.length - 1 ? 'mb-3' : 'pb-3'"
                    >
                    <div class="d-flex align-items-center ps-0 mb-1">
                      <span class="section-title">{{ group.description }}</span>
                      @if (group.description == 'Transporte') {
                        <mat-slide-toggle
                          class="ms-3 mb-0"
                          formControlName="{{ group.id }}"
                          (change)="pachControlValue($event, group.id, true)"
                          >
                          Carga y Entrega
                        </mat-slide-toggle>
                      }
                    </div>
                    @if (group.description != 'Transporte') {
                      <div class="row mb-2 ms-2">
                        <mat-select
                          class="ps-3 ms-3 pe-2"
                          placeholder="Subcategorías"
                          multiple
                          (selectionChange)="pachControlValue($event.value, group.id)"
                          formControlName="{{ group.id }}"
                          >
                          @for (job of jobs | filterByTaskGroup : group.id; track job) {
                            <mat-option
                              [value]="job"
                              >
                              {{ job.description }}
                            </mat-option>
                          }
                        </mat-select>
                      </div>
                    }
                  </div>
                }
              </form>
              <div class="line"></div>
              <div class="row buttons-footer justify-content-end me-4 pb-3">
                <button class="ind-button-lite float-right" (click)="closeSkillForm()">
                  <span>Cancelar</span>
                </button>
                <button
                  class="ind-button float-right"
                  type="submit"
                  (click)="onSubmit()"
                  [disabled]="hasChanges"
                  >
                  <span>Guardar cambios</span>
                </button>
              </div>
            </div>
          </div>
        }
      </div>
